import './feature.scss';

export default () => {
};
